import { render, staticRenderFns } from "./MapaAlertasSocioambientais.vue?vue&type=template&id=22873ee4&lang=pug"
import script from "./MapaAlertasSocioambientais.vue?vue&type=script&lang=js"
export * from "./MapaAlertasSocioambientais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports